import { Routes } from '@angular/router';
import {
  fichaProspectoCanMatch,
  PERFILES_FICHA_PROSPECTO,
  pendingAccessCanMatch,
  routeProfileCanMatch,
} from './core/access/route-profile-access';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    title: 'Inicio',
    loadComponent: () =>
      import('./features/home/pages/home.page').then((m) => m.HomePageComponent),
  },

  {
    path: 'perfil',
    title: 'Perfil de identidad activa',
    loadComponent: () =>
      import('./features/perfil/perfil.shell').then((m) => m.PerfilShellComponent),
  },

  {
    path: 'cartera',
    title: 'Cartera comercial',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/cartera' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Cartera comercial',
        loadComponent: () => import('./features/cartera/pages').then((m) => m.CarteraPageComponent),
      },
      {
        path: 'parametros/estados',
        title: 'Parámetros de estados de cartera',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/cartera/parametros/estados', perfilesPermitidos: ['administrador'] },
        loadComponent: () =>
          import('./features/cartera/pages').then((m) => m.CarteraParametrosEstadosPageComponent),
      },
    ],
  },

  {
    path: 'funnel',
    title: 'Embudo comercial',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/funnel' },
    loadComponent: () => import('./features/funnel/pages').then((m) => m.FunnelPageComponent),
  },

  {
    path: 'reportes',
    title: 'Reportes y paneles',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/reportes' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Reportes y paneles',
        loadComponent: () => import('./features/reportes/pages').then((m) => m.ReportesPageComponent),
      },
      {
        path: 'isa',
        title: 'Informe Semanal del Asesor (ISA)',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/reportes', perfilesPermitidos: ['jefe_comercial', 'director'] },
        loadComponent: () => import('./features/reportes/pages').then((m) => m.IsaPageComponent),
      },
    ],
  },

  {
    path: 'asignacion',
    title: 'Bandeja de leads',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/asignacion' },
    loadComponent: () =>
      import('./features/asignacion/shell').then((m) => m.AsignacionShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'bandeja',
      },
      {
        path: 'bandeja',
        title: 'Bandeja de leads',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/asignacion/bandeja' },
        loadComponent: () => import('./features/asignacion/pages').then((m) => m.AsignacionBandejaPageComponent),
      },
      {
        path: 'excepciones',
        title: 'Excepciones de asignación',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/asignacion/excepciones' },
        loadComponent: () => import('./features/asignacion/pages').then((m) => m.AsignacionExcepcionesPageComponent),
      },
      {
        path: 'reglas',
        title: 'Reglas de asignación',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/asignacion/reglas' },
        loadComponent: () => import('./features/asignacion/pages').then((m) => m.AsignacionReglasPageComponent),
      },
      {
        path: 'reasignacion-automatica',
        title: 'Reasignación automática',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/asignacion/reasignacion-automatica' },
        loadComponent: () => import('./features/asignacion/pages').then((m) => m.ReasignacionAutomaticaPageComponent),
      },
      {
        path: 'motivos-reasignacion',
        title: 'Motivos de reasignación',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/asignacion/motivos-reasignacion' },
        loadComponent: () => import('./features/asignacion/pages').then((m) => m.MotivosReasignacionPageComponent),
      },
      {
        path: 'historial/:leadId',
        title: 'Historial del lead',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/asignacion', perfilesPermitidos: ['agente_ventas', 'jefe_comercial', 'administrador'] },
        loadComponent: () => import('./features/asignacion/pages').then((m) => m.AsignacionHistorialPageComponent),
      },
    ],
  },

  {
    path: 'sla',
    title: 'SLA de primer contacto',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/sla' },
    loadComponent: () => import('./features/sla/shell').then((m) => m.SlaShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'SLA de primer contacto',
        loadComponent: () => import('./features/sla/pages').then((m) => m.SlaPageComponent),
      },
    ],
  },

  {
    path: 'disponibilidad',
    title: 'Disponibilidad de agentes',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/disponibilidad' },
    loadComponent: () =>
      import('./features/disponibilidad/shell').then((m) => m.DisponibilidadShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Disponibilidad de agentes',
        loadComponent: () =>
          import('./features/disponibilidad/pages').then((m) => m.DisponibilidadPageComponent),
      },
    ],
  },

  {
    // FE-82 defecto 1: ruta hermana (no hija) de 'prospectos' para que administrador entre a
    // la ficha, de solo lectura, sin abrir la lista 'Mi cartera'. Debe ir antes que 'prospectos'
    // en este arreglo: así se resuelve primero para cualquier URL de 2 segmentos y 'nuevo'/
    // 'agenda' (los únicos hijos literales de ese mismo largo) caen al candado de abajo.
    path: 'prospectos/:prospectoId',
    canMatch: [fichaProspectoCanMatch],
    data: { menuAccess: '/prospectos/:prospectoId', perfilesPermitidos: PERFILES_FICHA_PROSPECTO },
    loadComponent: () =>
      import('./features/prospectos/shell').then((m) => m.ProspectosShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Ficha del prospecto',
        loadComponent: () =>
          import('./features/prospectos/pages/prospecto-detalle.page').then((m) => m.ProspectoDetallePageComponent),
      },
    ],
  },

  {
    path: 'prospectos',
    title: 'Mi cartera',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/prospectos' },
    loadComponent: () =>
      import('./features/prospectos/shell').then((m) => m.ProspectosShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Mi cartera',
        loadComponent: () =>
          import('./features/prospectos/pages/prospectos-home.page').then((m) => m.ProspectosHomePageComponent),
      },
      {
        path: 'nuevo',
        title: 'Nuevo prospecto',
        loadComponent: () =>
          import('./features/prospectos/pages/prospecto-form.page').then((m) => m.ProspectoFormPageComponent),
      },
      {
        path: 'agenda',
        title: 'Agenda comercial',
        loadComponent: () =>
          import('./features/prospectos/pages').then((m) => m.ProspectosAgendaPageComponent),
      },
      {
        path: ':prospectoId/seguimiento',
        title: 'Seguimiento del prospecto',
        loadComponent: () =>
          import('./features/prospectos/pages').then((m) => m.ProspectoSeguimientoPageComponent),
      },
      {
        path: ':prospectoId/cierre-prospeccion',
        title: 'Cierre en prospección',
        loadComponent: () =>
          import('./features/prospectos/pages').then((m) => m.ProspectoCierreProspeccionPageComponent),
      },
      {
        path: ':prospectoId/cierre-perdida',
        title: 'Cierre como pérdida',
        loadComponent: () =>
          import('./features/prospectos/pages/prospecto-cierre-perdida.page').then(
            (m) => m.ProspectoCierrePerdidaPageComponent,
          ),
      },
      {
        path: ':prospectoId/consolidaciones',
        title: 'Consolidación de duplicados',
        loadComponent: () =>
          import('./features/prospectos/pages').then((m) => m.ProspectoConsolidacionesPageComponent),
      },
    ],
  },

  {
    path: 'cargas-masivas',
    title: 'Cargas masivas',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/cargas-masivas' },
    loadComponent: () =>
      import('./features/ingesta-prospectos/shell').then((m) => m.IngestaProspectosShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Cargas masivas',
        loadComponent: () =>
          import('./features/ingesta-prospectos/pages').then((m) => m.CargasMasivasPageComponent),
      },
      {
        path: ':cargaId',
        title: 'Detalle de carga masiva',
        loadComponent: () =>
          import('./features/ingesta-prospectos/pages').then((m) => m.CargaMasivaDetallePageComponent),
      },
    ],
  },

  {
    path: 'recepciones',
    title: 'Recepciones API',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/recepciones' },
    loadComponent: () =>
      import('./features/ingesta-prospectos/shell').then((m) => m.IngestaProspectosShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Recepciones API',
        loadComponent: () =>
          import('./features/ingesta-prospectos/pages').then((m) => m.RecepcionesPageComponent),
      },
    ],
  },

  {
    path: 'campanas',
    title: 'Campañas',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/campanas' },
    loadComponent: () =>
      import('./features/campanas/shell').then((m) => m.CampanasShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Campañas',
        loadComponent: () => import('./features/campanas/pages').then((m) => m.CampanasPageComponent),
      },
      {
        path: 'catalogos',
        title: 'Catálogos de campaña',
        loadComponent: () =>
          import('./features/campanas/pages').then((m) => m.CatalogosCampanaPageComponent),
      },
      {
        path: 'recupero',
        pathMatch: 'full',
        redirectTo: '/recupero',
      },
      {
        path: ':campanaId',
        title: 'Detalle de campaña',
        loadComponent: () =>
          import('./features/campanas/pages').then((m) => m.CampanaDetallePageComponent),
      },
    ],
  },

  {
    path: 'recupero',
    title: 'Recupero',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/recupero' },
    loadComponent: () =>
      import('./features/campanas/shell').then((m) => m.CampanasShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Recupero',
        loadComponent: () => import('./features/campanas/pages').then((m) => m.RecuperoPageComponent),
      },
    ],
  },

  {
    path: 'catalogos-comerciales',
    title: 'Catálogos comerciales',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/catalogos-comerciales' },
    loadComponent: () =>
      import('./features/catalogos-comerciales/shell').then(
        (m) => m.CatalogosComercialesShellComponent,
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Catálogos comerciales',
        loadComponent: () =>
          import('./features/catalogos-comerciales/pages').then(
            (m) => m.CatalogosComercialesHomePageComponent,
          ),
      },
      {
        path: 'bitacora',
        title: 'Bitácora',
        loadComponent: () =>
          import('./features/catalogos-comerciales/pages').then(
            (m) => m.CatalogosComercialesBitacoraPageComponent,
          ),
      },
      {
        path: ':catalogoCodigo',
        title: 'Detalle de catálogo comercial',
        loadComponent: () =>
          import('./features/catalogos-comerciales/pages').then(
            (m) => m.CatalogoComercialDetallePageComponent,
          ),
      },
    ],
  },

  {
    path: 'equivalencias-inveb',
    title: 'Equivalencias INVEB',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/equivalencias-inveb' },
    loadComponent: () =>
      import('./features/inveb/pages/equivalencias-inveb.page').then((m) => m.EquivalenciasInvebPageComponent),
  },

  {
    path: 'migracion-inveb',
    title: 'Migración INVEB',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/migracion-inveb' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Migración INVEB',
        loadComponent: () =>
          import('./features/inveb/pages/migracion-inveb.page').then((m) => m.MigracionInvebPageComponent),
      },
      {
        path: 'cargas/:cargaId',
        title: 'Carga de migración',
        canMatch: [routeProfileCanMatch],
        data: { menuAccess: '/migracion-inveb', perfilesPermitidos: ['administrador', 'director', 'soporte'] },
        loadComponent: () =>
          import('./features/inveb/pages/carga-migracion-detalle.page').then(
            (m) => m.CargaMigracionDetallePageComponent,
          ),
      },
    ],
  },

  {
    path: 'pipeline-canales',
    title: 'Pipeline por canal',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/pipeline-canales' },
    loadComponent: () =>
      import('./features/pipeline-canales/pages').then((m) => m.PipelineCanalesPageComponent),
  },

  {
    path: 'matriz-campos',
    title: 'Matriz de campos',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/matriz-campos' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Matriz de campos',
        loadComponent: () =>
          import('./features/matriz-campos/pages').then((m) => m.MatrizCamposListadoPageComponent),
      },
      {
        path: 'bitacora',
        title: 'Bitácora de la matriz de campos',
        loadComponent: () =>
          import('./features/matriz-campos/pages').then((m) => m.MatrizCamposBitacoraPageComponent),
      },
      {
        path: ':scopeId',
        title: 'Detalle de la matriz de campos',
        loadComponent: () =>
          import('./features/matriz-campos/pages').then((m) => m.MatrizCamposDetallePageComponent),
      },
    ],
  },

  {
    path: 'periodo-gestion',
    title: 'Período de gestión',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/periodo-gestion' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Período de gestión',
        loadComponent: () =>
          import('./features/periodo-gestion/pages').then((m) => m.PeriodoGestionPageComponent),
      },
      {
        path: 'regularizar',
        title: 'Regularizar período de gestión',
        loadComponent: () =>
          import('./features/periodo-gestion/pages').then((m) => m.PeriodoGestionRegularizarPageComponent),
      },
    ],
  },

  {
    path: 'auditoria',
    title: 'Auditoría',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/auditoria' },
    loadComponent: () => import('./features/auditoria/pages').then((m) => m.AuditoriaPageComponent),
  },

  {
    path: 'sincronizacion-office365',
    title: 'Sincronización con Office 365',
    canMatch: [routeProfileCanMatch],
    data: { menuAccess: '/sincronizacion-office365' },
    loadComponent: () =>
      import('./features/sincronizacion-office365/shell').then((m) => m.SincronizacionOffice365ShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Sincronización con Office 365',
        loadComponent: () =>
          import('./features/sincronizacion-office365/pages').then((m) => m.SincronizacionOffice365PageComponent),
      },
    ],
  },

  {
    path: 'acceso-restringido',
    title: 'Acceso restringido',
    loadComponent: () =>
      import('./features/acceso-restringido/pages/acceso-restringido.page').then(
        (m) => m.AccesoRestringidoPageComponent,
      ),
  },

  {
    path: 'sin-sesion',
    title: 'Sin sesión',
    canMatch: [pendingAccessCanMatch('sin_sesion')],
    data: { motivo: 'sin_sesion' },
    loadComponent: () =>
      import('./features/acceso-restringido/pages/acceso-pendiente.page').then(
        (m) => m.AccesoPendientePageComponent,
      ),
  },

  {
    path: 'mfa-requerido',
    title: 'Verifica tu segundo factor (MFA)',
    canMatch: [pendingAccessCanMatch('mfa_pendiente')],
    data: { motivo: 'mfa_pendiente' },
    loadComponent: () =>
      import('./features/acceso-restringido/pages/acceso-pendiente.page').then(
        (m) => m.AccesoPendientePageComponent,
      ),
  },

  {
    path: '**',
    title: 'Pantalla no encontrada',
    loadComponent: () =>
      import('./features/acceso-restringido/pages/pantalla-no-encontrada.page').then(
        (m) => m.PantallaNoEncontradaPageComponent,
      ),
  },
];
